var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[`status-btn--${_vm.status}`, 'status-btn'],attrs:{"aria-label":_vm.ariaLabel},on:{"click":function($event){return _vm.$emit('click')}}},[_c('iconic',{class:`atomIconic-btn--${_vm.status}`,attrs:{"name":_vm.status}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }